// extracted by mini-css-extract-plugin
export var content = "points-title-module--content--7b2fg";
export var keton = "points-title-module--keton--P5Fnm";
export var pointsTitle = "points-title-module--points-title--BGN-3";
export var title = "points-title-module--title--RymBt";